import SecondarySidebarLayout from "components/wrappers/SecondarySidebarLayout";
import AddUser from "pages/settings/AddUser";
import EditUser from "pages/settings/EditUser";
import LeaveDocuments from "pages/settings/LeaveDocuments";
import Permissions from "pages/settings/Permissions";
import Roles from "pages/settings/Roles";
// import Permissions from "pages/settings/Permissions";
// import Roles from "pages/settings/Roles";
import Users from "pages/settings/Users";
import { Navigate, Outlet } from "react-router-dom";
import usePermissions from "hooks/usePermission";
import filterByPermissions from "utils/filterByPermissions";
import ProtectedOutlet from "components/wrappers/ProtectedOutlet";
import { PermissionCodename } from "constants/permission";

interface UserAccessControlRoute {
  path: string;
  element: JSX.Element;
  children?: UserAccessControlRoute[];
  permission?: PermissionCodename;
}

export default function useUserAccessControlRoutes() {
  const { hasPermissionTo } = usePermissions();

  const children: UserAccessControlRoute[] = [
    {
      path: "",
      element: <Navigate to="users" />,
    },
    {
      path: "users",
      element: <Outlet />,
      children: [
        {
          path: "",
          element: <Users />,
        },
        {
          path: "add",
          element: <AddUser />,
        },
        {
          path: ":id",
          element: <EditUser />,
        },
      ],
    },
    {
      path: "Leave Documents",
      permission: "view_leave_balance_bulk_upload_log",
      element: (
        <ProtectedOutlet requiredPermission="view_leave_balance_bulk_upload_log">
          <LeaveDocuments />
        </ProtectedOutlet>
      ),
    },
    {
      path: "Roles",
      permission: "add_roles_permission_template",
      element: (
        <ProtectedOutlet requiredPermission="add_roles_permission_template">
          <Roles />
        </ProtectedOutlet>
      ),
    },
  ];

  const filteredList = filterByPermissions(children, hasPermissionTo);

  return {
    path: "settings/user-access-control",
    element: (
      <SecondarySidebarLayout list={filteredList} title="User Access Control">
        <Outlet />
      </SecondarySidebarLayout>
    ),
    children,
  };
}
